import store from "../store/appStore";
import {
  SET_DOWNLOADING_VISIBILITY,
  SET_FILE_DOWNLOADING
} from "../store/loader/actionTypes";
import * as loaderActionType from "../store/loader/actionTypes";
import { API_HEADERS, API_URL } from "../constants/api";
import { ShowToast, toastType } from "./toast-service";
import { DOWNLOAD_STATUS } from "../constants/constants";
import { GetUserConfiguration } from "./helper";
import commonLabels from "../constants/messageConstants";

/**
 * call on download new file in new tab
 * @param {*} url
 */
function downloadFileInNewTab(url) {
  window.open(url, "_blank");
}

/**
 * random string generator depends upon condition
 * @param {*} length
 * @returns
 */
function generateString(length) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = " ";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

/**
 * set downloading status
 * @param {*} downloadingKey
 * @param {*} fileName
 * @param {*} status
 */
function setDownloadingStatus(
  downloadingKey = "",
  fileName = "",
  status = "downloading"
) {
  store.dispatch({
    type: SET_FILE_DOWNLOADING,
    payload: {
      details: {
        dKey: downloadingKey,
        fileName: fileName,
        status: DOWNLOAD_STATUS[status]
      }
    }
  });
}

/**
 * call on download excel report
 * @param {*} url
 * @param {*} filename
 * @param {*} fileMimeType
 */
function downloadReportExcel(
  url,
  filename = "Report",
  fileMimeType = "application/vnd.ms-excel"
) {
  const urlWithId = `${url}`;
  downloadExcelReportByAPI(urlWithId, filename, fileMimeType);
}

/**
 * print function
 * @param {*} reportAbsoluteURL
 * @param {*} fileName
 * @param {*} fileMimeType
 */
async function printForm(
  reportAbsoluteURL,
  // eslint-disable-next-line no-unused-vars
  fileName = "Report",
  fileMimeType = "application/pdf",
  type = ""
) {
  const userData = GetUserConfiguration();
  store.dispatch({
    type: loaderActionType.SET_VISIBILITY,
    payload: true
  });
  fetch(API_URL.getReportDownload, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `${API_HEADERS.authName} ${localStorage.getItem(
        API_HEADERS.authToken
      )}`,
      cloudOrgId: localStorage.getItem(API_HEADERS.CID),
      CID: localStorage.getItem(API_HEADERS.CID),
      EMAIL: "dc.administrator@stream-dc.com",
      "Cache-Control": "no-cache"
    },
    body: JSON.stringify({
      AbsoluteUri: `${reportAbsoluteURL}&CloudOrgId=2&EmailID=${userData.email}`,
      FileMimeType: fileMimeType
    })
  }).then(response => {
    if (response.status === 200) {
      response.blob().then(blob => {
        const url = window.URL.createObjectURL(blob);
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = encodeURI(url);
        document.body.appendChild(iframe);
        iframe.contentWindow.focus();
        setTimeout(() => {
          iframe.contentWindow.print();
        }, 4000);
        store.dispatch({
          type: loaderActionType.SET_VISIBILITY,
          payload: false
        });
      });
    } else {
      store.dispatch({
        type: loaderActionType.SET_VISIBILITY,
        payload: false
      });
      const message =
        type === "HSE"
          ? commonLabels.printHSEMessageError.message
          : type === "Security"
          ? commonLabels.printSecurityMessageError.message
          : commonLabels.printBRRABRFMessageError.message;
      ShowToast(message, toastType.ERROR);
    }
  });
}

/**
 * call on download excel report
 * @param {*} reportAbsoluteURL
 * @param {*} fileName
 * @param {*} fileMimeType
 */
function downloadExcelReportByAPI(
  reportAbsoluteURL,
  fileName = "Report",
  fileMimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
) {
  const userData = GetUserConfiguration();
  const accessGroupId = userData?.groups[0]?.accessGroupId || 0;
  const filename = fileName;
  const downloadingKey = generateString(6);
  setDownloadingStatus(downloadingKey, fileName, "downloading");
  fetch(API_URL.getReportDownload, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `${API_HEADERS.authName} ${localStorage.getItem(
        API_HEADERS.authToken
      )}`,
      cloudOrgId: localStorage.getItem(API_HEADERS.CID),
      CID: localStorage.getItem(API_HEADERS.CID),
      EMAIL: "dc.administrator@stream-dc.com",
      "Cache-Control": "no-cache"
    },
    body: JSON.stringify({
      AbsoluteUri: `${reportAbsoluteURL}&CloudOrgId=2&EmailID=${userData.email}&AccessGroupId=${accessGroupId}`,
      FileMimeType: fileMimeType
    })
  }).then(response => {
    if (response.status === 200) {
      response.blob().then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style = "display: none";
        a.href = url;
        a.download = filename;
        a.click();
        setDownloadingStatus(downloadingKey, filename, "completed");
      });
    } else {
      ShowToast(
        "Facing issues while downloading report, Please contact your administrator.",
        toastType.ERROR
      );
      setDownloadingStatus(downloadingKey, filename, "failed");
    }
  });
}

/**
 * set downloader visibility
 * @param {*} flag
 */
function visibilityDownloaderProgress(flag = false) {
  store.dispatch({
    type: SET_DOWNLOADING_VISIBILITY,
    payload: flag
  });
}

export {
  downloadFileInNewTab,
  downloadReportExcel,
  downloadExcelReportByAPI,
  visibilityDownloaderProgress,
  setDownloadingStatus,
  generateString,
  printForm
};
